import { NimmstaDataSource, Pageable, SFSOptions } from '@nimmsta/ng-commons-lib';
import { lastValueFrom, Observable, switchMap } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { Configuration } from '../models/configuration';
import { ConfigurationService } from './configuration.service';
import { OrganizationNameService } from '../pages/configurations/organization-name.service';

export class ConfigurationDatasource extends NimmstaDataSource<Configuration> {
  forAdmin = false;

  constructor(protected configurationService: ConfigurationService, private organizationService: OrganizationNameService) {
    super(configurationService);
  }

  override loadData(options?: Partial<SFSOptions>): Observable<Pageable<Configuration>> {
    const optionsCopy = { ...options };
    if (!this.forAdmin) {
      const params = new HttpParams().set('forceOrgSelection', 'true');
      if (!options) {
        return super.loadData({ additionalQueryParams: params });
      }
      if (!options.additionalQueryParams) {
        optionsCopy.additionalQueryParams = params;
      } else {
        optionsCopy.additionalQueryParams = options.additionalQueryParams.set('forceOrgSelection', 'true');
      }
      return super.loadData(optionsCopy);
    }
    return super.loadData(optionsCopy).pipe(switchMap(async (page) => {
      const orgIds = page.content.map((c) => c.organizationIds).flat();
      if (orgIds.length > 0) {
        await lastValueFrom(this.organizationService.getNameMap(orgIds));
      }
      return page;
    }));
  }
}
